module.exports = __webpack_public_path__ + "static/media/contactMail.5f915405.png";